module.exports = __webpack_public_path__ + "img/CLVHelp1.03b84d80.png";